import { render, staticRenderFns } from "./noticeViewAllList.vue?vue&type=template&id=82d96dbe&scoped=true"
import script from "./noticeViewAllList.vue?vue&type=script&lang=js"
export * from "./noticeViewAllList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d96dbe",
  null
  
)

export default component.exports